import {fetchBaseQuery,createApi} from '@reduxjs/toolkit/query/react'
import { baseURL } from '../config'
import { authHeader } from '../CommonMethods/Auth-Headers'
import { CheckUserStatus } from '../CommonMethods/CheckUserStatus';


async function myCustomBaseQuery(args, api, extraOptions) {
    //const dispatch=useDispatch()
    // Call your function before making the API call
    const status=await CheckUserStatus()

    if (!status) {

        return;
    }
    // Customize the query options based on the pre-API call data if needed
    
  
    // Proceed with the API call using fetchBaseQuery
    return fetchBaseQuery({ 
        baseUrl: baseURL,
        prepareHeaders:async(headers,{getState})=>{
            const header = await authHeader()
            headers.set('authorization',header.Authorization)
            return headers
        },

    })(args, api, extraOptions)
    
    
}
  
export const usersList = createApi({
    
    reducerPath: 'usersList',
    baseQuery:myCustomBaseQuery,
 
    tagTypes:['User','History'],
    
    
    endpoints: (builder) => ({
        emailVerified:builder.mutation({
            query:({body})=>({
                url:`users/verify-email-address`,
                method:'POST',
                body:body
            }),
        }),

        ViewPatient:builder.query({
            query:()=>`/patients/patient-details`,
        }),
        exportPatientNotes:builder.mutation({
            query:({dateformat,patientId,noteType})=>({
                url:`patients/export-note/${patientId}?note_type=${noteType}`,
                method:'POST',
                body:{"dateformat":dateformat,"timezone":Intl.DateTimeFormat().resolvedOptions().timeZone,}
            }),
        }),
        ViewGraphPatient:builder.query({
            query:()=>`/patients/patient-details?action=graph`,
        }),  
        
    
   
})
})

export const {
    useEmailVerifiedMutation,
    useViewPatientQuery,
    useExportPatientNotesMutation,
    useViewGraphPatientQuery

}=usersList





